import React, { useState, useEffect } from "react";
import SelectInput from "../common/SelectInput";
import TopNavigation from "../common/TopNavigation";
import AttestationTypeList from '../common/AttestationTypeList';
import DocumentCheckBox from '../common/DocumentCheckBox';



function AttestationService(props) {
  const { values, errors, dirty, handleOnChange, setData, navigation, t } = props

  const [attestationNatureLookup, setAttestationNatureLookup] = useState([]);
  const [isAlreadyAttested, setAlreadyAttested] = useState(false);
  const [paAttestationTypesList, setPaAttestationTypesList] = useState([]);
  const [caAttestationTypesList, setCaAttestationTypesList] = useState([]);
  const [mapDocumentCheckBox, setMapDocumentCheckBox] = useState([]);
  const [attestationTypeLookup, setAttestationTypeLookup] = useState([]);
  const [numberOfDocument, setNumberOfDocument] = useState(1);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  


  const {
    configuration,
    attestationNatureCode,
    attestationTypeCode
  } = values;


  const {
    showAlreadyAttestedOption,
    showAttestationTypeList,
    showAttestationDescription
  } = configuration;

  const activeFields = [];

  if (showAttestationTypeList === 1) {
    activeFields.push("attestationTypeCode");
  }

  const isStepInvalid = () => {
    const stepInputs = [
      ...activeFields,
      "attestationNatureCode"
    ];
    const nullValues = stepInputs.filter((input) => {
      return values[input] === "--";
    });
    const errorValues = stepInputs.filter((input) => {
      return errors[input] !== "";
    });

   

    return nullValues.length ||
      errorValues.length
      ? true
      : false;
  };

  const setAttestationAmount = () => {

    calcuNumberOfCopy();
    var productInfo = values.productInfo;

    setData({ "name": "attestationServiceCharges", value: "0" });
    setData({ "name": "attestationDeliveryFees", value: "0" });
    setData({ "name": "attestationTotalAmount", value: "0" });

    if (isAlreadyAttested) {
      productInfo.forEach(item => {
        if (item.attestationCode === attestationNatureCode && item.serviceCharges === 0) {
          setData({ "name": "amount", value: item.deliveryFees });
          setData({ "name": "vat", value: item.vat });
          const calculatedTotal = (parseFloat(item.deliveryFees) + parseFloat(item.vat)).toFixed(2);
          setData({ "name": "totalAmount", value: calculatedTotal });
        }
      })
    } else {
      productInfo.forEach(item => {
        if (item.attestationCode === attestationNatureCode && item.serviceCharges !== 0) {
          setData({ "name": "amount", value: item.deliveryFees });
          setData({ "name": "attestationServiceCharges", value: item.serviceCharges });
          setData({ "name": "vat", value: item.vat });
          const calculatedTotal = (parseFloat(item.deliveryFees) + (parseFloat(item.serviceCharges) * numberOfDocument) + parseFloat(item.vat)).toFixed(2);

          setData({ "name": "totalAmount", value: calculatedTotal });
        }
      })
    }

    if (showAlreadyAttestedOption === 0)
      setData({ "name": "alreadyAttested", value: false });

    navigation.next();
  }

  const concatnateSpecialNotes = (docList) => {

    var result = '';
    docList.map((item) => {
      if (result === '')
        result = item.documentName + ':' + item.quantity;
      else
        result = result + "," + item.documentName + ':' + item.quantity;

    });

    setData({ "name": "SpecialNotes", value: result });
  }


  const onChangeDocumentNumber = (numberOfCopy, selectedDocument,isDecreased) => {


    if (values.numberOfDocument >= values.maxNumberOfCopy && isDecreased) {
      setData({ "name": "maxDocumentSelected", value: true });
      return;
    }


    setData({ "name": "attestationTypeCode", value: selectedDocument });

    var itemUpdated = false;
    const newList = selectedDocuments.map((item) => {
      if (item.documentName === selectedDocument) {
        const updatedItem = {
          ...item,
          quantity: numberOfCopy,
        };
        itemUpdated = true;
        return updatedItem;
      } else
        return item;
    });
    if (itemUpdated === false) {
      var selecteDoc = { "documentName": selectedDocument, "quantity": numberOfCopy };
      selectedDocuments.push(selecteDoc);
      setSelectedDocuments(selectedDocuments);
     

    } else {
      setSelectedDocuments(newList);

    }
    if (itemUpdated == false) {

      var newQuantity = selectedDocuments.reduce((a, v) => a = a + v.quantity, 0);
      setNumberOfDocument(newQuantity);
      setData({ "name": "numberOfDocument", value: newQuantity });
      setData({ "name": "maxDocumentSelected", value: false });
    } else {
      var newQuantity = newList.reduce((a, v) => a = a + v.quantity, 0);
      setNumberOfDocument(newQuantity);
      setData({ "name": "numberOfDocument", value: newQuantity });
      setData({ "name": "maxDocumentSelected", value: false });

    }
    

  }

  const onChangeRemoveDocument = (selectedDocument) => {
    const newList = selectedDocuments.filter((item) => item.documentName !== selectedDocument);
    setSelectedDocuments(newList);
    var newQuantity = newList.reduce((a, v) => a = a + v.quantity, 0);
    setNumberOfDocument(newQuantity);
    setData({ "name": "numberOfDocument", value: newQuantity });
    setData({ "name": "maxDocumentSelected", value: false });
    if(newQuantity==0)
      setData({ "name": "attestationTypeCode", value: ''});
  }

  const calcuNumberOfCopy = () => {

    var quantity = selectedDocuments.reduce((a, v) => a = a + v.quantity, 0);
    setNumberOfDocument(quantity);
    concatnateSpecialNotes(selectedDocuments);
    setData({ "name": "numberOfDocument", value: quantity });
  }

  const handleAlreadyAttested = (event) => {
    setData({ "name": "alreadyAttested", value: event.target.checked });
    setAlreadyAttested(event.target.checked);
  }

  const mapToDocumentCheckBox = async (data) => {
    var newItem;
    var mapList = [];
      data.map((item) => {
        newItem = { "code": item.code, "nameEn": item.nameEn, "nameAr":item.nameAr, "selected": false };
        mapList.push(newItem);
      });
      setMapDocumentCheckBox(mapList);
  }

  const attestationNatureHandler = (event) => {

    handleOnChange(event);
    setData({ "name": "attestationNatureCode", value: event.target.value });
    setData({ "name": "attestationNatureName", value: event.target[event.target.selectedIndex].text });
    setData({ "name": "attestationTypeCode", value: ''});
    setData({ "name": "isRequireMultipleDocument", value: false });
    
    if (!event.target.value) {  
      setAttestationTypeLookup([]);
      setData({ "name": "numberOfDocument", value: 1 });
      setData({ "name": "maxDocumentSelected", value: false });
      setNumberOfDocument(0);
      setData({ "name": "numberOfDocument", value: 1});
      setSelectedDocuments([]);
      return;
    }

    setData({ "name": "numberOfDocument", value: 1 });
    setData({ "name": "maxDocumentSelected", value: false });

    setSelectedDocuments([]);

    attestationNatureLookup.forEach(element => {
      if (element.code === event.target.value) {
        setAttestationTypeLookup(element.attestationTypes);
        mapToDocumentCheckBox(element.attestationTypes)
        setData({ "name": "attestationTypeLookup", value: element.attestationTypes });
        setData({ "name": "attestationNatureCode", value: event.target.value });
        setData({ "name": "attestationNatureName", value: event.target[event.target.selectedIndex].text });

        if (element.maxNumberOfCopy !== null && element.maxNumberOfCopy > 1) {      
          setData({ "name": "isRequireMultipleDocument", value: true });
          setData({"name":"numberOfDocument",value:1}); 
          setNumberOfDocument(1);
          if(showAlreadyAttestedOption === 0)                          
            setSelectedDocuments([{"documentName":event.target[event.target.selectedIndex].text ,"quantity":1}]);   
          setData({ "name": "maxNumberOfCopy", value: element.maxNumberOfCopy });
        }
        else {
          setData({ "name": "isRequireMultipleDocument", value: false });
          setData({ "name": "numberOfDocument", value: 1 });
          setData({ "name": "maxNumberOfCopy", value: element.maxNumberOfCopy });

        }
      }
    });
  }

  const onChangeNumberCopy = (event) => {

    handleOnChange(event);
    setNumberOfDocument(event.target.value);
    setData({ "name": "numberOfDocument", value: event.target.value });
  }

  const onIncreaseNumberCopy = (event) => {
    if (values.numberOfDocument < values.maxNumberOfCopy) {
      setNumberOfDocument(numberOfDocument + 1);
      setSelectedDocuments([{ "documentName": values.attestationNatureName, "quantity": numberOfDocument + 1 }]);
      setData({ "name": "numberOfDocument", value: numberOfDocument + 1 });
    }
  }

  const onDecreaseNumberCopy = (event) => {
    if (values.numberOfDocument > 1) {
      setNumberOfDocument(numberOfDocument - 1);
      setSelectedDocuments([{ "documentName": values.attestationNatureName, "quantity": numberOfDocument - 1 }]);
      setData({ "name": "numberOfDocument", value: numberOfDocument - 1 });
    }

  }



  useEffect(() => {

    setData({ "name": "SpecialNotes", value: '' });

    if (!values.numberOfDocument)
      {
        setNumberOfDocument(0);
        setData({ "name": "numberOfDocument", value: 1});
      }else
    
      setNumberOfDocument(values.numberOfDocument);

      fetch(
        process.env.REACT_APP_PRODUCTS_API_BASE_URL + "/services/embassy/api/Attestation/"+values.selectedEmbassyCode
    )
      .then((response) => response.json())
      .then((data) => {
        setAttestationNatureLookup(data);

        data.forEach(element => {
          if (element.code === 'PA')
            setPaAttestationTypesList(element.attestationTypes);
          if (element.code === 'CA')
            setCaAttestationTypesList(element.attestationTypes);
        });
      });
  }, []);


  return (
    <div>
      <div className="container-md">
        <div className="top-section">
          <TopNavigation {...props} />
        </div>
        <div className="mid-selection mt-4">
          <div className="row ">  {/* align-items-center*/}
            <div className="col-sm-5">
              <div className="embassy-section">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="consulate-selection mb-2 pb-3 mt-2">
                          <h2 className="mb-3">   {values.locale === "en" ? values.embassyNameEn : values.embassyNameAr} {t("ATTESTATION_SERVICE")}</h2>
                          <p className="sub-head">
                            {t("ATTESTATION_SERVICE_EXPECTED")}
                          </p>
                        </div>

                        {showAttestationDescription === 1 && (
                          <div className="consulate-selection mb-4 pb-3 mt-2">
                            <p className="sub-desc">
                              {t("ATTESTATION_DESCRIPTION")}
                            </p>
                            {showAttestationDescription === 1 && (<AttestationTypeList t={t} language={values.locale} paAttestationTypesList={paAttestationTypesList} caAttestationTypesList={caAttestationTypesList} />)}
                          </div>
                        )}

                        <h4>
                          {t("ENTER_REQUIRED_FIELDS")}:
                        </h4>
                        <div className="row">
                          <div className="col-sm-10 mt-2 mb-2">
                            <SelectInput
                              className="form-control form-select"
                              id="attestationNatureCode"
                              name="attestationNatureCode"
                              label={t("ATTESTATION_NATURE")}
                              onChange={attestationNatureHandler}
                              value={attestationNatureCode}
                              validation={{ errors, dirty }}
                              defaultText={t("SELECT_ATTESTATION")}
                              itemLookUp={attestationNatureLookup}
                              language={values.locale}
                              t={t}
                            />
                          </div>
                        </div>

                        {values.attestationNatureCode == '' && (
                          <div className="row"></div>
                        )}
                        {showAttestationTypeList === 1 && values.attestationTypeLookup && values.attestationNatureCode != '' && (
                          <div className="row">
                            <div class=" " id="accordionFlushExample">
                              <div class="accordion-body attestation">
                               
                                <div className="mb-2">
                                  <h5>{t("ATTESTATION_TYPE")}<span className="max-document-alert"> ({t("MAX_DOCUMENT_MESSAGE")})</span></h5>
                                  
                                  </div>
                              
                                
                                {

                                  mapDocumentCheckBox && mapDocumentCheckBox.map((item) => {
                                    return (
                                      <DocumentCheckBox
                                        t={t}
                                        language={values.locale}
                                        item={item}
                                        maxDocumentSelected={values.maxDocumentSelected}
                                        numberOfDocument={values.numberOfDocument}
                                        maxNumberOfCopy={values.maxNumberOfCopy}
                                        onChangeDocumentNumber={onChangeDocumentNumber}
                                        onChangeRemoveDocument={onChangeRemoveDocument}
                                      />
                                    );
                                  })
                                }
                              </div>
                            </div>
                          </div>
                        )}
                        {showAlreadyAttestedOption === 1 && (
                          <div className="row">
                            <div className="col-sm-12 mt-2 mb-3">
                              <div className="mofa-attestation">
                                <p className="sub-head">
                                  {t("ATTESTED_DOCUMENT")}
                                </p>

                                <div className="col-sm-12 my-2">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value={isAlreadyAttested}
                                      onChange={handleAlreadyAttested}
                                      id="accept-terms"
                                    />
                                    <label className="form-check-label" htmlFor="accept-terms">
                                      {t("ATTESTED_DOCUMENT_OPTION")}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {
                          values.isRequireMultipleDocument && showAlreadyAttestedOption === 0 && (
                            <div class="form-group input-group mb-3">
                              <label>{t('QUANTITY')}</label>
                              <div class="input-group mb-3 ">
                                <div class="input-group-prepend">
                                  <button class="btn  button-minus" type="button" onClick={onDecreaseNumberCopy}></button>
                                </div>
                                <input type="text" onChange={onChangeNumberCopy} disabled={true} class="downup-input" aria-label="Small" placeholder="Copies" value={values.numberOfDocument}  ></input>
                                <div class="input-group-prepend">
                                  <button class="btn  button-plus" type="button" onClick={onIncreaseNumberCopy}></button>
                                </div>
                              </div>
                            </div>
                          )
                        }
                      </div>
                      <div className="col-sm-12">
                        <div className="row">
                          <div className="col-6 my-3 dir-left">
                            <button
                              className="btn btn-lg btn-default btn-back "
                              onClick={() => {
                                navigation.go("select-embassy");
                              }}
                              disabled={false}
                            >
                              <img src="./images/arrow-left.svg" alt="" />
                              {t("BACK")}
                            </button>
                          </div>
                          <div className="col-6 my-3  dir-right">
                            <button
                              className="btn btn-primary btn-lg emx-button"
                              onClick={() => setAttestationAmount()}
                              disabled={isStepInvalid() || numberOfDocument==0}
                            >
                              {t("PROCEED")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-1">&nbsp;</div>
            <div className="col-sm-6">
              <div className="col-sm-12 mt-3">
                <img
                  src={"data:image/jpeg;base64, " + values.rigthSideImage}
                  alt="Embassy Logo"
                  className="rigth-side-image"
                />
              </div>
            </div>
          </div>
          <div className="row column my-3"></div>
        </div>
      </div>

    </div>
  );
}

export default AttestationService;